import { Row } from "@circle-react-uikit/SkeletonLoader/components";
import { BillingDetailsContainer } from "./BillingDetailsContainer";

export const PlanDetailsSkeleton = () => (
  <BillingDetailsContainer>
    <div className="flex flex-col gap-y-4">
      <div className="flex flex-col gap-2">
        <Row xxl half />
        <div className="flex flex-row items-center gap-1">
          <Row lg short />
          <Row sm short />
        </div>
      </div>

      <div className="flex flex-col gap-y-3">
        {Array.from({ length: 2 }, (_, index) => (
          <div key={index} className="flex flex-col gap-1">
            <Row lg short />
            <Row sm half />
            <Row sm almostFull />
          </div>
        ))}
      </div>
    </div>
  </BillingDetailsContainer>
);
